module.exports = __webpack_public_path__ + "img/php.f7a7ae25.png";